import React from 'react';
import MaterialUITypography, { TypographyProperties } from '../Typography';

const Headline2 = ({ tag, ...properties }: TypographyProperties) => (
  <MaterialUITypography
    tag={tag}
    variant="h2"
    {...properties}
  />
);

export default Headline2;
